import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import ModalVideo from 'react-modal-video';
import Lightbox from 'react-18-image-lightbox';
import Select from 'react-select';
import { API_BASE, getImageUrl } from '../utils/api'

import floor from '../assets/img/floor.jpg'
import image1 from '../assets/img/pl-6.jpg'
import user1 from '../assets/img/user-1.jpg'
import user5 from '../assets/img/user-5.jpg'
import edu from '../assets/img/edu.png'
import food from '../assets/img/food.png'

import '../../node_modules/react-modal-video/css/modal-video.css'
import '../../node_modules/react-18-image-lightbox/style.css'

interface DBAgent {
    _id: string; name: string; email: string; role: string; phone?: string;
    about?: string; city?: string; state?: string; avatar?: string;
}

interface DBProperty {
    _id: string; title: string; price: number; status: string; type: string;
    city?: string; address?: string; bedrooms?: number; bathrooms?: number; area?: string;
    images?: string[]; isActive: boolean; isFeatured?: boolean; createdAt: string;
    description?: string; features?: string[]; buildingAge?: string; garage?: string; rooms?: string;
    owner?: DBAgent;
    floorPlans?: {
        name: string;
        size: string;
        description: string;
        image: string;
    }[];
    dynamicAmenities?: {
        name: string;
        icon: string;
    }[];
    videoUrl?: string;

    // Advanced Details
    subCategory?: string;
    furnishing?: string;
    totalFloors?: number;
    propertyFloor?: number;
    totalRooms?: number;
    facing?: string;
    sellType?: string;
    constructionStatus?: string;
    reraRegistered?: boolean;
    reraNumber?: string;
    balcony?: number;
    liftAvailable?: boolean;
    powerBackup?: boolean;
    societyName?: string;
    gatedCommunity?: boolean;
    cornerProperty?: boolean;
    parkFacing?: boolean;
    roadWidth?: string;
    nearbyMetro?: boolean;
    parkingType?: string;
    totalParking?: number;
}

export default function PropertyDetail({ item, propertyId }: { item: DBProperty; propertyId?: string }) {
    const [isOpen, setIsOpen] = useState(false);
    let [open, setOpen] = useState<boolean>(true);
    let [open2, setOpen2] = useState<boolean>(true);
    let [open3, setOpen3] = useState<boolean>(true);
    let [open4, setOpen4] = useState<boolean>(false);
    let [open5, setOpen5] = useState<boolean>(true);
    let [open6, setOpen6] = useState<boolean>(true);
    let [open7, setOpen7] = useState<boolean>(true);
    let [open8, setOpen8] = useState<boolean>(true);
    let [open9, setOpen9] = useState<boolean>(true);
    let [open10, setOpen10] = useState<boolean>(true);
    let [show, setShow] = useState<boolean>(false);
    let [show2, setShow2] = useState<boolean>(false);
    let [show3, setShow3] = useState<boolean>(false);

    const [activeIndex, setActiveIndex] = useState<number>(0)
    const [photo, setPhoto] = useState<boolean>(false)
    const [activeFloorIndex, setActiveFloorIndex] = useState<number>(0)

    // Reviews state
    const [reviews, setReviews] = useState<any[]>([])
    const [reviewForm, setReviewForm] = useState({ name: '', email: '', rating: '', message: '' })
    const [submitting, setSubmitting] = useState(false)
    const [reviewSuccess, setReviewSuccess] = useState('')
    const [reviewError, setReviewError] = useState('')

    // Fetch reviews on mount
    useEffect(() => {
        if (!propertyId) return
        fetch(`${API_BASE}/reviews/${propertyId}`)
            .then(res => res.json())
            .then(data => { if (Array.isArray(data)) setReviews(data) })
            .catch(err => console.error('Failed to fetch reviews', err))
    }, [propertyId])

    // Submit review
    const handleReviewSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!reviewForm.name || !reviewForm.email || !reviewForm.rating || !reviewForm.message) {
            setReviewError('Please fill all fields.'); return
        }
        setSubmitting(true); setReviewError(''); setReviewSuccess('')
        try {
            const res = await fetch(`${API_BASE}/reviews`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ property: propertyId, ...reviewForm, rating: Number(reviewForm.rating) })
            })
            const data = await res.json()
            if (res.ok) {
                setReviews(prev => [data, ...prev])
                setReviewForm({ name: '', email: '', rating: '', message: '' })
                setReviewSuccess('Your review has been submitted successfully!')
                setTimeout(() => setReviewSuccess(''), 4000)
            } else {
                setReviewError(data.message || 'Failed to submit review.')
            }
        } catch {
            setReviewError('Server error. Please try again.')
        } finally {
            setSubmitting(false)
        }
    }

    const onImageClick = (index: number) => {
        setActiveIndex(index)
        setPhoto(true)
    }

    // Helper: render stars
    const renderStars = (count: number) => {
        const stars = []
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <i key={i} className={`fa-star ${i <= count ? 'fa-solid text-warning' : 'fa-regular text-muted'}`}
                    style={{ fontSize: '16px', marginRight: '2px' }}></i>
            )
        }
        return stars
    }

    const rating = [
        { value: '1', label: '⭐ 1 Star' },
        { value: '2', label: '⭐⭐ 2 Stars' },
        { value: '3', label: '⭐⭐⭐ 3 Stars' },
        { value: '4', label: '⭐⭐⭐⭐ 4 Stars' },
        { value: '5', label: '⭐⭐⭐⭐⭐ 5 Stars' },
    ]

    const propertyGallery = item.images && item.images.length > 0 ? item.images : [image1];

    return (
        <>
            <div className="property_block_wrap style-2" id="detail-features">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen(!open)} className={open ? '' : 'collapsed'}><h4 className="property_block_title">Detail & Features</h4></Link>
                </div>
                <div id="clOne" className={`panel-collapse collapse ${open ? 'show' : ''}`}>
                    <div className="block-body">
                        <ul className="deatil_features" style={{ fontSize: '1.1rem' }}>
                            <li><strong>Status:</strong>{item.status}</li>
                            <li><strong>Type:</strong>{item.type}</li>
                            {item.subCategory && <li><strong>Category:</strong>{item.subCategory}</li>}
                            <li><strong>Price:</strong>₹{item.price?.toLocaleString()}</li>
                            <li><strong>Area:</strong>{item.area || 0} sqft</li>

                            {/* Conditional Residential Fields */}
                            {['Apartment', 'Villa', 'House', 'Residential', 'Flat', 'Duplex', 'Penthouse', 'Studio', 'Houses', 'Independent House'].includes(item.type) && (
                                <>
                                    <li><strong>Bedrooms:</strong>{item.bedrooms || 0}</li>
                                    <li><strong>Bathrooms:</strong>{item.bathrooms || 0}</li>
                                    {(item.balcony || 0) > 0 && <li><strong>Balcony:</strong>{item.balcony}</li>}
                                </>
                            )}

                            {/* Commercial/Office Washrooms */}
                            {['Commercial', 'Office', 'Shop', 'Warehouse', 'Industrial', 'Factory', 'Office Space'].includes(item.type) && (
                                <li><strong>Washrooms:</strong>{item.bathrooms || 0}</li>
                            )}

                            {(item.totalRooms || 0) > 0 && <li><strong>Total Rooms:</strong>{item.totalRooms}</li>}
                            {item.furnishing && <li><strong>Furnishing:</strong>{item.furnishing}</li>}
                            {item.constructionStatus && <li><strong>Construction:</strong>{item.constructionStatus}</li>}
                            {item.sellType && <li><strong>Sell Type:</strong>{item.sellType}</li>}

                            <li><strong>Building Age:</strong>{item.buildingAge || 'N/A'}</li>
                            {(item.totalFloors || 0) > 0 && <li><strong>Total Floors:</strong>{item.totalFloors}</li>}
                            {(item.propertyFloor || 0) > 0 && <li><strong>Floor No:</strong>{item.propertyFloor}</li>}

                            {item.facing && <li><strong>Facing:</strong>{item.facing}</li>}
                            <li><strong>Garage/Parking:</strong>{item.garage || 'No'}</li>

                            {item.societyName && <li><strong>Society:</strong>{item.societyName}</li>}
                            {item.reraRegistered && (
                                <li className="text-success"><strong>RERA Registered:</strong>Yes {item.reraNumber ? `(${item.reraNumber})` : ''}</li>
                            )}

                            {item.gatedCommunity && <li><strong>Gated Community:</strong>Yes</li>}
                            {item.cornerProperty && <li><strong>Corner Property:</strong>Yes</li>}
                            {item.parkFacing && <li><strong>Park Facing:</strong>Yes</li>}
                            {item.roadWidth && <li><strong>Road Width:</strong>{item.roadWidth}</li>}

                            <li><strong>City:</strong>{item.city || 'N/A'}</li>
                        </ul>
                    </div>
                </div>

            </div>

            <div className="property_block_wrap style-2" id="description">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen2(!open2)} className={open2 ? '' : 'collapsed'}><h4 className="property_block_title">Description</h4></Link>
                </div>
                <div id="clTwo" className={`panel-collapse collapse ${open2 ? 'show' : ''}`}>
                    <div className="block-body">
                        {item.description ? (
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>{item.description}</p>
                        ) : (
                            <p style={{ fontSize: '1.1rem' }}>No description provided for this property.</p>
                        )}
                    </div>
                </div>
            </div>

            <div className="property_block_wrap style-2" id="amenities">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen3(!open3)} className={open3 ? '' : 'collapsed'}><h4 className="property_block_title">Ameneties</h4></Link>
                </div>
                <div id="clThree" className={`panel-collapse collapse ${open3 ? 'show' : ''}`}>
                    <div className="block-body">
                        <ul className="avl-features third">
                            {item.dynamicAmenities && item.dynamicAmenities.length > 0 ? (
                                item.dynamicAmenities.map((am, idx) => (
                                    <li key={idx} className="d-flex align-items-center mb-2" style={{ fontSize: '1.1rem' }}>
                                        {am.icon && (am.icon.startsWith('http') || am.icon.startsWith('/') || am.icon.includes('.')) ? (
                                            <img src={getImageUrl(am.icon)} alt={am.name} className="me-2 rounded shadow-sm" style={{ width: '38px', height: '38px', objectFit: 'contain', display: 'inline-block' }} />
                                        ) : (
                                            <i className={`${am.icon} me-2 text-primary`} style={{ width: '40px', textAlign: 'center', fontSize: '36px' }}></i>
                                        )}
                                        <span className="fw-medium">{am.name}</span>
                                    </li>
                                ))
                            ) : item.features && item.features.length > 0 ? (
                                item.features.map((feature, idx) => (
                                    <li key={idx}>{feature}</li>
                                ))
                            ) : (
                                <li>No amenities listed.</li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="property_block_wrap style-2" id="property-video">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen4(!open4)} className={open4 ? '' : 'collapsed'}><h4 className="property_block_title">Property video</h4></Link>
                </div>

                <div id="clFour" className={`panel-collapse collapse ${open4 ? 'show' : ''}`}>
                    <div className="block-body">
                        {item.videoUrl ? (
                            <div className="property_video">
                                <div className="thumb">
                                    <img className="pro_img img-fluid w100" src={propertyGallery[0]} alt="Property Video" />
                                    <div className="overlay_icon">
                                        <div className="bb-video-box">
                                            <div className="bb-video-box-inner">
                                                <div className="bb-video-box-innerup">
                                                    <Link to="#" onClick={() => setIsOpen(true)} className="text-primary"><i className="fa-solid fa-play"></i></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-4 bg-light rounded">
                                <p className="text-muted mb-0">No video available for this property.</p>
                            </div>
                        )}
                    </div>
                </div>
                {item.videoUrl && (
                    <ModalVideo
                        channel="youtube"
                        youtube={{ mute: 0, autoplay: 0 }}
                        isOpen={isOpen}
                        videoId={(() => {
                            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                            const match = item.videoUrl?.match(regExp);
                            return (match && match[2].length === 11) ? match[2] : '';
                        })()}
                        onClose={() => setIsOpen(false)}
                    />
                )}

            </div>

            <div className="property_block_wrap style-2" id="floor-plan">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen5(!open5)} className={open5 ? '' : 'collapsed'}><h4 className="property_block_title">Floor Plan</h4></Link>
                </div>
                <div id="clFive" className={`panel-collapse collapse ${open5 ? 'show' : ''}`}>
                    <div className="block-body">
                        {!item.floorPlans || item.floorPlans.length === 0 ? (
                            <div className="text-center py-3 bg-light rounded">
                                <p className="text-muted mb-0">No floor plans available.</p>
                            </div>
                        ) : (
                            <div className="accordion" id="floor-option">
                                {item.floorPlans.map((fp, idx) => (
                                    <div className="card shadow-none border mb-2" key={idx}>
                                        <div className="card-header bg-white" id={`fp-h-${idx}`}>
                                            <h2 className="mb-0">
                                                <button type="button"
                                                    className={`btn btn-link w-100 text-start d-flex justify-content-between align-items-center text-decoration-none py-3 px-4 ${activeFloorIndex === idx ? '' : 'collapsed'}`}
                                                    onClick={() => setActiveFloorIndex(activeFloorIndex === idx ? -1 : idx)}
                                                    style={{ color: '#0a1f6e', fontWeight: 'bold', fontSize: '1.1rem' }}
                                                >
                                                    {fp.name}
                                                    <span className="badge bg-light text-primary border fw-normal" style={{ fontSize: '0.9rem' }}>{fp.size}</span>
                                                </button>
                                            </h2>
                                        </div>
                                        <div className={`collapse ${activeFloorIndex === idx ? 'show' : ''}`}>
                                            <div className="card-body p-4 border-top">
                                                {fp.image && <img src={fp.image} className="img-fluid rounded mb-3 shadow-sm" alt={fp.name} />}
                                                <p className="text-muted mb-0 small">{fp.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="property_block_wrap style-2" id="location">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen6(!open6)} className={open6 ? '' : 'collapsed'}><h4 className="property_block_title">Location</h4></Link>
                </div>
                <div id="clSix" className={`panel-collapse collapse ${open6 ? 'show' : ''}`}>
                    <div className="block-body">
                        <div className="map-container">
                            <iframe src={`https://www.google.com/maps?q=${encodeURIComponent(item.address || '')}+${encodeURIComponent(item.city || '')}&output=embed`} width="100%" height="450" style={{ border: '0' }} loading="lazy" title='myframe'></iframe>
                        </div>
                    </div>
                </div>
            </div>

            <div className="property_block_wrap style-2" id="gallery">

                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen7(!open7)} className={open7 ? '' : 'collapsed'}><h4 className="property_block_title">Gallery</h4></Link>
                </div>

                <div id="clSev" className={`panel-collapse collapse ${open7 ? 'show' : ''}`}>
                    <div className="block-body">
                        <ul className="list-gallery-inline">
                            {propertyGallery.map((img: any, index: number) => {
                                return (
                                    <li key={index}>
                                        <Link to="#" className="mfp-gallery" onClick={() => onImageClick(index)}><img src={img} className="img-fluid mx-auto" alt="" /></Link>
                                    </li>
                                )
                            })}
                        </ul>
                        {photo && (
                            <Lightbox
                                mainSrc={propertyGallery[activeIndex]}
                                nextSrc={propertyGallery[(activeIndex + 1) % propertyGallery.length]}
                                prevSrc={propertyGallery[(activeIndex + propertyGallery.length - 1) % propertyGallery.length]}
                                onCloseRequest={() => setPhoto(false)}
                                onMovePrevRequest={() => setActiveIndex((activeIndex + propertyGallery.length - 1) % propertyGallery.length)
                                }
                                onMoveNextRequest={() => setActiveIndex((activeIndex + 1) % propertyGallery.length)
                                }
                            />
                        )}
                    </div>
                </div>

            </div>

            {/* ─── Reviews Section ─── */}
            <div className="property_block_wrap style-2" id="reviews">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen10(!open10)} className={open10 ? '' : 'collapsed'}><h4 className="property_block_title">Reviews ({reviews.length})</h4></Link>
                </div>
                <div id="clTen" className={`panel-collapse collapse ${open10 ? 'show' : ''}`}>
                    <div className="block-body">

                        {/* Existing Reviews List */}
                        {reviews.length > 0 ? (
                            <div className="mb-4">
                                {reviews.map((rev, idx) => (
                                    <div key={rev._id || idx} className="d-flex gap-3 mb-3 pb-3" style={{ borderBottom: idx < reviews.length - 1 ? '1px solid #eee' : 'none' }}>
                                        <div style={{
                                            width: '50px', height: '50px', borderRadius: '50%', flexShrink: 0,
                                            background: 'linear-gradient(135deg, #0a1f6e, #1a3a9e)',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            color: '#fff', fontWeight: 'bold', fontSize: '20px'
                                        }}>
                                            {rev.name?.charAt(0)?.toUpperCase() || 'U'}
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <div className="d-flex justify-content-between align-items-start flex-wrap">
                                                <div>
                                                    <h6 className="mb-0 fw-bold">{rev.name}</h6>
                                                    <div className="mt-1">{renderStars(rev.rating)}</div>
                                                </div>
                                                <small className="text-muted" style={{ fontSize: '12px' }}>
                                                    {new Date(rev.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                                                </small>
                                            </div>
                                            <p className="text-muted mb-0 mt-2" style={{ fontSize: '14px', lineHeight: '1.6' }}>{rev.message}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-3 mb-4 bg-light rounded" style={{ border: '1px dashed #ced4da' }}>
                                <i className="fa-regular fa-comment-dots fa-2x mb-2" style={{ color: '#adb5bd' }}></i>
                                <p className="mb-0 text-muted">No reviews yet. Be the first to review this property!</p>
                            </div>
                        )}

                        {/* Write Review Form */}
                        <h5 className="fw-bold mb-3" style={{ color: '#0a1f6e' }}>
                            <i className="fa-solid fa-pen-to-square me-2"></i>Write a Review
                        </h5>

                        {reviewSuccess && (
                            <div className="alert alert-success py-2 mb-3" style={{ fontSize: '14px', borderRadius: '8px' }}>
                                <i className="fa-solid fa-check-circle me-1"></i>{reviewSuccess}
                            </div>
                        )}
                        {reviewError && (
                            <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '14px', borderRadius: '8px' }}>
                                <i className="fa-solid fa-circle-exclamation me-1"></i>{reviewError}
                            </div>
                        )}

                        <form className="form-submit" onSubmit={handleReviewSubmit}>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group">
                                        <textarea className="form-control ht-80" placeholder="Write your review..."
                                            value={reviewForm.message}
                                            onChange={e => setReviewForm(p => ({ ...p, message: e.target.value }))}></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group">
                                        <Select
                                            options={rating}
                                            placeholder="Choose Rating"
                                            className="form-control p-0 border-0"
                                            value={reviewForm.rating ? rating.find(r => r.value === reviewForm.rating) : null}
                                            onChange={(opt: any) => setReviewForm(p => ({ ...p, rating: opt?.value || '' }))}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Your Name"
                                            value={reviewForm.name}
                                            onChange={e => setReviewForm(p => ({ ...p, name: e.target.value }))} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Your Email"
                                            value={reviewForm.email}
                                            onChange={e => setReviewForm(p => ({ ...p, email: e.target.value }))} />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group">
                                        <button className="btn btn-primary fw-medium px-lg-5 rounded" type="submit" disabled={submitting}>
                                            {submitting ? (
                                                <><span className="spinner-border spinner-border-sm me-2"></span>Submitting...</>
                                            ) : 'Submit Review'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
